import { t } from "./i18n";

// What a checkout buys; the result page words its message and next step from it.
export const CHECKOUT_KINDS = ["subscription", "pass", "renewal", "game"];

// The payment provider returns the payer to the checkout result page. Zarinpal also adds
// `ref` (the bank tracking code) or `reason`; see zarinpal_pay.service.handle_callback.
export function checkoutReturnUrls(kind) {
  const base = `${window.location.origin}/checkout/result?kind=${kind}`;
  return { successUrl: `${base}&status=success`, cancelUrl: `${base}&status=failed` };
}

export function isVerificationRequired(error) {
  return error?.response?.data?.code === "verification_required";
}

// Backend messages are written in English; t() shows their translation on Persian servers.
export function paymentErrorMessage(error, fallback) {
  const response = error?.response;
  if (!response) return t("Could not reach the server. Check your connection and try again.");
  if (response.status >= 500) return t("The payment service is not responding. Please try again in a few minutes.");
  const detail = response.data?.detail;
  return typeof detail === "string" && detail ? t(detail) : fallback;
}
